/**
 * Brand constants — single source of truth for product naming.
 * Change here, rebrand the whole frontend in one edit.
 */
export const BRAND_NAME = "AI Counsel";
export const BRAND_KICKER = "Practice OS";
export const BRAND_TAGLINE = "Practice OS for modern law firms";
export const BRAND_FOOTER = "A practice management platform for trial-ready firms.";
export const BRAND_COPYRIGHT_YEAR = 2026;
